import React from "react"
import PropTypes from "prop-types"

const Delivery = ({ fillColor }) => (
  <svg
    width="25"
    height="21"
    viewBox="0 0 25 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.98347L3.71901 0H21.3499L25 7.98347V19.7686C25 21.1625 21.3499 21.416 21.3499 19.7686V17.741H3.71901V19.7686C3.71901 21.1625 0 21.0358 0 19.7686V7.98347ZM3.09921 7.53987L5.57854 1.96411H19.697L22.3829 7.53987H3.09921ZM22.4516 12.292C22.4516 13.4117 21.4649 14.3195 20.2478 14.3195C19.0306 14.3195 18.0439 13.4117 18.0439 12.292C18.0439 11.1722 19.0306 10.2644 20.2478 10.2644C21.4649 10.2644 22.4516 11.1722 22.4516 12.292ZM4.95853 14.3195C6.17568 14.3195 7.16238 13.4117 7.16238 12.292C7.16238 11.1722 6.17568 10.2644 4.95853 10.2644C3.74137 10.2644 2.75467 11.1722 2.75467 12.292C2.75467 13.4117 3.74137 14.3195 4.95853 14.3195Z"
      fill={fillColor}
    />
  </svg>
)

Delivery.propsTypes = {
  fillColor: PropTypes.string,
}

Delivery.defaultProps = {
  fillColor: "var(--page-color)",
}

export { Delivery }
